import { Button, Col, Divider, Input, message, Row, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useHandleSubmitApi } from "hook";
import { IMediaOutputModel, IUpdateMediaInputModel } from "interfaces/media";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { MediaServices } from "services/media";
import { OtherUtil } from "utils/other";

export interface IMediaInformationContentProps {
  data: IMediaOutputModel;
  onUpdateOrCreateCompleted?: () => void;
}

export default function MediaInformationContent(props: IMediaInformationContentProps) {
  const { Text } = Typography;
  const [value, setValue] = useState<IMediaOutputModel>({ ...props.data });

  useEffect(() => {
    setValue(props.data);
  }, [props.data]);

  const handleChange = <T extends keyof IMediaOutputModel>(key: T, value: IMediaOutputModel[T]) => {
    setValue((prev) => ({ ...prev, [key]: value }));
  };

  const [updateMediaService, loadingMedia] = useHandleSubmitApi(
    async (data: IUpdateMediaInputModel) => {
      const dataRes = await MediaServices.updateMedia(data.id, data);
      if (dataRes) {
        message.success("Cập nhật thành công!");
        props.onUpdateOrCreateCompleted && props.onUpdateOrCreateCompleted();
      }
    },
    () => message.error("Có lỗi xảy ra, vui lòng thử lại sau!")
  );
  const items: { label: string; children: () => React.ReactNode }[] = [
    {
      label: "Tên tệp tin",
      children: () => <Text>{value?.metadata?.originName}</Text>,
    },
    {
      label: "Loại tệp tin",
      children: () => <Text>{value?.metadata?.type}</Text>,
    },
    {
      label: "Dung lượng tệp",
      children: () => <Text>{value?.metadata?.size}</Text>,
    },
    {
      label: "Kích thước",
      children: () => (
        <Text>
          {value?.metadata?.width} x {props.data?.metadata?.height}
        </Text>
      ),
    },
    {
      label: "Đã tải lên",
      children: () => <Text>{moment(value?.createdAt).format("YYYY/MM/DD HH:mm:ss")}</Text>,
    },
    {
      label: "Cập nhật gần nhất",
      children: () => <Text>{moment(value?.updatedAt).format("YYYY/MM/DD HH:mm:ss")}</Text>,
    },
    {
      label: "Tải lên bởi",
      children: () => <Text>{OtherUtil.getFullname(value?.createdBy?.firstName, value?.createdBy?.lastName)}</Text>,
    },
  ];

  const handleSubmit = async () => {
    await updateMediaService(value);
  };

  const renderInformation = () => {
    return (
      <>
        <Typography>
          <h3 className="mt_0">Thông tin hình ảnh</h3>
          {items.map((i, idx) => {
            return (
              <div key={idx} className="mb_0-5">
                <b>
                  <Text>{`${i.label}`}</Text>:
                </b>{" "}
                {i.children()}
              </div>
            );
          })}
        </Typography>
        <Divider />
        <div className="media-list-information__body-right_input">
          <Row gutter={[25, 10]} className="media-list-information__body-right_input-item">
            <Col span={6} className="media-list-information__body-right_input-item_title">
              <span>Văn bản thay thế:</span>
            </Col>
            <Col span={18}>
              <TextArea
                rows={3}
                placeholder="Để trống nếu như hình ảnh chỉ dùng làm hiệu ứng trang trí"
                value={value?.alt}
                onChange={(e) => handleChange("alt", e.target.value)}
              />
            </Col>
          </Row>

          <Row gutter={[25, 10]} className="media-list-information__body-right_input-item">
            <Col span={6} className="media-list-information__body-right_input-item_title">
              <span>Tiêu đề:</span>
            </Col>
            <Col span={18}>
              <Input
                size="large"
                placeholder="Tiêu đề hình ảnh"
                value={value?.title}
                onChange={(e) => handleChange("title", e.target.value)}
              />
            </Col>
          </Row>

          <Row gutter={[25, 10]} className="media-list-information__body-right_input-item">
            <Col span={6} className="media-list-information__body-right_input-item_title">
              <span>Chú thích:</span>
            </Col>
            <Col span={18}>
              <TextArea
                rows={3}
                placeholder="Nhập chú thích"
                value={value?.note}
                onChange={(e) => handleChange("note", e.target.value)}
              />
            </Col>
          </Row>

          <Row gutter={[25, 10]} className="media-list-information__body-right_input-item">
            <Col span={6} className="media-list-information__body-right_input-item_title">
              <span>Mô tả:</span>
            </Col>
            <Col span={18}>
              <TextArea
                rows={3}
                placeholder="Nhập mô tả"
                value={value?.description}
                onChange={(e) => handleChange("description", e.target.value)}
              />
            </Col>
          </Row>

          <Row gutter={[25, 10]} className="media-list-information__body-right_input-item">
            <Col span={6} className="media-list-information__body-right_input-item_title">
              <span>Liên kết:</span>
            </Col>
            <Col span={18}>
              <Input size="large" placeholder="Liên kết hình ảnh" disabled value={value?.path} />
              <Button
                size="middle"
                className="mt_1"
                color="primary"
                variant="dashed"
                style={{ width: 200 }}
                onClick={() => {
                  message.success("Sao chép thành công!");
                  navigator.clipboard.writeText(value?.path);
                }}
              >
                Sao chép liên kết
              </Button>
            </Col>
          </Row>
        </div>
        <Divider />
        <Button
          size="large"
          className="w_100 btn"
          style={{ marginLeft: "auto" }}
          onClick={() => handleSubmit()}
          disabled={loadingMedia}
          loading={loadingMedia}
        >
          Cập nhật
        </Button>
      </>
    );
  };

  return <React.Fragment>{renderInformation()}</React.Fragment>;
}
